exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-fade {\n    display: inherit !important; /* override v-show display: none */\n    -webkit-transition: opacity 0.3s;\n    transition: opacity 0.3s;\n}\n.v-fade[style*=\"display: none;\"] {\n    opacity: 0;\n    pointer-events: none; /* disable user interaction */\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; /* disable user selection */\n}\n", ""]);

// exports
